import { apiSlice } from '../../api/apiSlice';

export const persistApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDropdownValues: builder.mutation({
      query: () => ({
        url: 'Persist/dropdowns',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateCourseId: builder.mutation({
      query: (courseId) => ({
        url: `Persist/courseid?courseId=${courseId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    updateClassId: builder.mutation({
      query: (classId) => ({
        url: `Persist/classid?classId=${classId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getPublicAssignment: builder.mutation({
      query: () => ({
        url: 'Persist/PublicAssignment',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updatePublicAssignment: builder.mutation({
      query: (options) => ({
        url: `Persist/PublicAssignment?courseId=${options.courseId}&archived=${options.archived}`,
        method: 'PUT',
        credentials: 'include',
        body: options.qTypes
      })
    }),
    getYourAssignment: builder.mutation({
      query: () => ({
        url: 'Persist/YourAssignment',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateYourAssignment: builder.mutation({
      query: (options) => ({
        url: `Persist/YourAssignment?courseId=${options.courseId}&folderId=${options.folderId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.qTypes
      })
    }),
    getCourseUsageDates: builder.mutation({
      query: () => ({
        url: 'Persist/CourseUsageReportDates',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentReportValues: builder.mutation({
      query: () => ({
        url: 'Persist/AssignmentReportValues',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateAssignmentReportValues: builder.mutation({
      query: (options) => ({
        url: 'Persist/AssignmentReportValues',
        method: 'PUT',
        credentials: 'include',
        body:{...options}
      })
    }),
    getTeacherReportOptions: builder.mutation({
      query: () => ({
        url: 'Persist/TeacherReportOptions',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateTeacherReportOptions: builder.mutation({
      query: (options) => ({
        url: 'Persist/TeacherReportOptions',
        method: 'PUT',
        credentials: 'include',
        params:{...options}
      })
    }),
    getTimeOnTaskPersist: builder.mutation({
      query: () => ({
        url: 'Persist/TimeOnTaskValues',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateTimeOnTaskPersist: builder.mutation({
      query: (options) => ({
        url: 'Persist/TimeOnTaskValues',
        method: 'PUT',
        credentials: 'include',
        body:{...options}
      })
    }),
    getAdminAssessmentReportValues: builder.mutation({
      query: () => ({
        url: 'Persist/AdminAssessmentReportValues',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateAdminAssessmentReportValues: builder.mutation({
      query: (options) => ({
        url: 'Persist/AdminAssessmentReportValues',
        method: 'PUT',
        credentials: 'include',
        body:{...options}
      })
    }),
    getRetakeSettings: builder.mutation({
      query: () => ({
        url: 'Persist/RetakeSettings',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentSetting: builder.mutation({
      query: () => ({
        url: 'Persist/AssignmentSettings',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getGrowthReportValues: builder.mutation({
      query: () => ({
        url: 'Persist/GrowthReportValues',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateGrowthReportValues: builder.mutation({
      query: (options) => ({
        url: 'Persist/GrowthReportValues',
        method: 'PUT',
        credentials: 'include',
        body:{...options}
      })
    }),
    getShowDeletedTeacherSets: builder.mutation({
      query: () => ({
        url: 'Persist/ShowDeletedTeacherSets',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateShowDeletedTeacherSets: builder.mutation({
      query: (options) => ({
        url: `Persist/ShowDeletedTeacherSets?showDeleted=${options.showDeleted}`,
        method: 'PUT',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetDropdownValuesMutation,
  useUpdateCourseIdMutation,
  useUpdateClassIdMutation,
  useGetPublicAssignmentMutation,
  useUpdatePublicAssignmentMutation,
  useGetYourAssignmentMutation,
  useUpdateYourAssignmentMutation,
  useGetCourseUsageDatesMutation,
  useGetAssignmentReportValuesMutation,
  useUpdateAssignmentReportValuesMutation,
  useGetTeacherReportOptionsMutation,
  useUpdateTeacherReportOptionsMutation,
  useGetTimeOnTaskPersistMutation,
  useUpdateTimeOnTaskPersistMutation,
  useGetAdminAssessmentReportValuesMutation,
  useUpdateAdminAssessmentReportValuesMutation,
  useGetRetakeSettingsMutation,
  useGetAssignmentSettingMutation,
  useGetGrowthReportValuesMutation,
  useUpdateGrowthReportValuesMutation,
  useGetShowDeletedTeacherSetsMutation,
  useUpdateShowDeletedTeacherSetsMutation
} = persistApi;